import http from './cart/http.service';

export const ventasService = {
    buscarMisVentas,
    buscarMisCompras,
    getVentaById,
    cambiarEstadoVendedor,
    cambiarEstadoComprador,
    buscarVentasTodas,
    subirComprobante
}


function cambiarEstadoVendedor(data) {
    const url = '/api/ventas/vendedor/cambiarEstado';
    return http.post(url, JSON.stringify(data));
}

function cambiarEstadoComprador(data) {
    const url = '/api/ventas/comprador/cambiarEstado';
    return http.post(url, JSON.stringify(data));
}

/** El comprobante viaja en base64 adentro del VentaDto, ya redimensionado por el front. */
function subirComprobante(data) {
    const url = '/api/ventas/comprador/subirComprobante';
    return http.post(url, JSON.stringify(data));
}

function getVentaById(data) {
    const url = '/api/ventas/getVentaById';
    return http.post(url, JSON.stringify(data));
}

function buscarMisCompras(data) {
    const url = '/api/ventas/comprador/buscar';
    return http.post(url, JSON.stringify(data));
}

function buscarMisVentas(data) {
    const url = '/api/ventas/vendedor/buscar';
    return http.post(url, JSON.stringify(data));
}

function buscarVentasTodas(data) {
    const url = '/api/admin/ventas/buscar';
    return http.post(url, JSON.stringify(data));
}
